
      window.addEventListener('error', function(event) {
        if (event.message && (
          event.message.includes('Failed to fetch dynamically imported module') || 
          event.message.includes('Failed to load module script') || 
          event.message.includes('Cannot access') || 
          event.message.includes('Could not establish connection')
        )) {
          console.warn('Non-critical module loading error:', event.message);
          // Prevent the error from bubbling up and breaking the app
          event.stopPropagation();
          event.preventDefault();
          return true;
        }
        return false;
      }, true);
    